import { Avatar, Box, Text } from '@factorialco/deprecated-design-system'
import {
  ProjectWorkerForSelectFragment,
  ProjectWorkerSelectorDocument,
  ProjectWorkerSelectorQuery,
} from 'generated/resources/graphql'

import { EntitySelector } from 'modules/core/components/EntitySelector'
import buildUrl from 'modules/core/lib/buildUrl'
import i18n from 'modules/core/lib/i18n'

const ProjectWorkerItem = ({ worker }: { worker: ProjectWorkerForSelectFragment }) => {
  return (
    <Box flexDirection="row" gap="s8" alignItems="center">
      <Avatar
        size="s32"
        url={buildUrl(worker.employee?.access?.avatar)}
        label={worker.employee?.access?.fullName || ''}
      />
      <Text.Normal>{worker.employee?.access?.fullName}</Text.Normal>
    </Box>
  )
}

interface ProjectWorkerSelectorProps {
  projectId: number
  label?: string
  value: ProjectWorkerForSelectFragment[]
  onChange: (value: ProjectWorkerForSelectFragment[]) => void
}

export const ProjectWorkerSelector: React.FC<ProjectWorkerSelectorProps> = ({
  label,
  projectId,
  value,
  onChange,
}) => {
  const variables = {
    projectId,
  }

  const extractConnection = (data: ProjectWorkerSelectorQuery) => {
    return data.projectManagement.projectWorkersConnection
  }

  const renderEntity = (entity: ProjectWorkerForSelectFragment) => {
    return <ProjectWorkerItem worker={entity} />
  }

  const commonProps = {
    document: ProjectWorkerSelectorDocument,
    extractConnection,
    label: label || i18n.t('project_management.selectors.project_workers.label'),
    renderEntity,
    variables,
  }

  return (
    <EntitySelector.Multiple
      {...commonProps}
      renderValue={(workers) => {
        return (
          <Text.Normal ellipsis>
            {workers.length > 0
              ? workers.map((worker) => worker.employee?.access?.fullName).join(', ')
              : i18n.t('common.select_multiple')}
          </Text.Normal>
        )
      }}
      value={value}
      onChange={onChange}
    />
  )
}
